import React from "react"

const AlertImageContext = React.createContext({ 
    src: "", 
    title: "", 
    body: "", 
    bodyfotter: "", 
    bool: false, 
    cenario: "", 
    dataFullerette: {}, 
    dataCoordinadora: {}, 
    dataGerente: {} 
});

export default AlertImageContext;
